import React from 'react';

const menuItems = [
    { label: 'ABOUT US', icon: '/images/StartAboutIcon.png' },
    { label: 'PORTFOLIO', icon: '/images/StartPortfolioIcon.png' },
    { label: 'NEWSPAPER', icon: '/images/StartNewsIcon.png' },
    { label: 'GALLERY', icon: '/images/StartGalleryIcon.png' },
    { label: 'CONTACT US', icon: '/images/StartContactIcon.png' },
    { label: 'RECYCLE BIN', icon: '/images/StartRecycleIcon.png' },
    { label: 'CLOSE EVERYTHING', icon: '/images/StartCloseAllIcon.png' },
];

const StartMenu = ({
    isAboutOpen, setIsAboutOpen,
    isPortfolioOpen, setIsPortfolioOpen,
    isContactOpen, setIsContactOpen,
    isGalleryOpen, setIsGalleryOpen,
    isNewsOpen, setIsNewsOpen,
    isRecycleOpen, setIsRecycleOpen,
    startMenuOpen, setStartMenuOpen,
    zFILO, addToZFILO, removeFromZFILO
}) => {
    const handleClick = (label) => {
        switch (label) {
            case 'ABOUT US':
                setIsAboutOpen(false);
                removeFromZFILO('about');
                setIsAboutOpen(true);
                addToZFILO('about');
                break;
            case 'PORTFOLIO':
                setIsPortfolioOpen(false);
                removeFromZFILO('portfolio');
                setIsPortfolioOpen(true);
                addToZFILO('portfolio');
                break;
            case 'NEWSPAPER':
                setIsNewsOpen(false);
                removeFromZFILO('news');
                setIsNewsOpen(true);
                addToZFILO('news');
                break;
            case 'GALLERY':
                setIsGalleryOpen(false);
                removeFromZFILO('gallery');
                setIsGalleryOpen(true);
                addToZFILO('gallery');
                break;
            case 'CONTACT US':
                setIsContactOpen(false);
                removeFromZFILO('contact');
                setIsContactOpen(true);
                addToZFILO('contact');
                break;
            case 'RECYCLE BIN':
                setIsRecycleOpen(false);
                removeFromZFILO('recycle');
                setIsRecycleOpen(true);
                addToZFILO('recycle');
                break;
            case 'CLOSE EVERYTHING':
                setIsAboutOpen(false);
                removeFromZFILO('about');

                setIsPortfolioOpen(false);
                removeFromZFILO('portfolio');

                setIsNewsOpen(false);
                removeFromZFILO('news');

                setIsGalleryOpen(false);
                removeFromZFILO('gallery');

                setIsContactOpen(false);
                removeFromZFILO('contact');

                setIsRecycleOpen(false);
                removeFromZFILO('recycle');
                break;
            default:
                break;
        }

        setStartMenuOpen(false);
    };

    return (
        <div className='StartMenu'>
            {menuItems.map((item, index) => (
                <button
                    key={index}
                    className='StartMenuItem'
                    onClick={() => handleClick(item.label)}
                >
                    <img src={item.icon} alt={`${item.label} Icon`} />
                    {item.label}
                </button>
            ))}
        </div>
    );
};

export default StartMenu;
